export default __webpack_public_path__ + "static/logo-8ba0697429408edfb294496085ea01cb.png";